<div class="header-component mainlogo">
  <img src="../../../../assets/img/openpay.png.png" height="80%" alt="Logo"/>
  <i class="icon-ICON7" [style.fontSize.px]="25"></i>
</div>
